import Animation from "../classes/Animation";

import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger)

export default class Parallax {
    constructor({ element }){
        this.element = element
        this.parallax = this.element.getAttribute('parallax')

        this.create()
    }

    create(){
        this.timeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.element,
                start: "top bottom",
                // end: "center center",
                scrub: true,
                // markers: true,
            }
        });

        if(this.element.parentNode.tagName == 'FIGURE' || this.element.parentNode.tagName == 'LI'){
            if(this.parallax > 0){
                this.timeline.to(this.element.parentNode, { yPercent: -15 * this.parallax })
            } else {
                this.timeline.from(this.element.parentNode, { yPercent: -15 * this.parallax })
            }
        } else {
            if(this.parallax > 0){
                this.timeline.to(this.element, { yPercent: 15 * this.parallax })
            } else {
                this.timeline.from(this.element, { yPercent: -15 * this.parallax })
            }
        }
    }
}